import { inject, Injectable } from '@angular/core';
import { ToastService } from '@circlek-global/lds-components';

import { TranslationService } from '~services/translation.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private readonly toastService = inject(ToastService);
  private readonly translationService = inject(TranslationService);

  error(titleTranslationKey: string, subtitleTranslationKey?: string): void {
    const { title, subtitle } = this.getTranslatedMessages(titleTranslationKey, subtitleTranslationKey);

    this.toastService.error(title, subtitle);
  }

  private getTranslatedMessages(
    titleTranslationKey: string,
    subtitleTranslationKey?: string,
  ): { title: string; subtitle: string } {
    return {
      title: this.translationService.translate(titleTranslationKey),
      subtitle: subtitleTranslationKey ? this.translationService.translate(subtitleTranslationKey) : '',
    };
  }
}
